(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("infiniteloading", [], factory);
	else if(typeof exports === 'object')
		exports["infiniteloading"] = factory();
	else
		root["infiniteloading"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 